import { render, staticRenderFns } from "./login4.vue?vue&type=template&id=1537f833&scoped=true&"
import script from "./login4.vue?vue&type=script&lang=js&"
export * from "./login4.vue?vue&type=script&lang=js&"
import style0 from "./login4.vue?vue&type=style&index=0&id=1537f833&prod&lang=scss&"
import style1 from "./login4.vue?vue&type=style&index=1&id=1537f833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537f833",
  null
  
)

export default component.exports